import * as React from "react"

const H2 = ({ className, children }) => (
  <h2 className={`text-5xl lg:text-6xl font-heading ${className}`}>
    {children}
  </h2>
)

export default H2
